import { JobTracker, LocalStorageJobStore } from "./job-tracker.service";

const TRACK_LEAD_BATCH_JOBS_KEY = "apexTrackedLeadBatchJobs";
const TRACKING_INTERVAL_MS = 5000;

export class LeadBatchJobTracker extends JobTracker {
    constructor($q, $interval, leadBatchService) {
        'ngInject';
        super($interval, new LocalStorageJobStore(TRACK_LEAD_BATCH_JOBS_KEY), TRACKING_INTERVAL_MS);
        this.$q = $q;
        this.leadBatchService = leadBatchService;
    }

    /**
     * Get the list of all jobs being tracked by the tracker currently.
     */
    retrieveTrackedJobs() {
        return this.$q.all(Array.from(this.jobIDs).map(id =>
            this.leadBatchService.retrieveLeadBatchJob(id)
                .then(job => {
                    if (!job) {
                        // Job was expired, so remove it from the tracking list.
                        this.stopTrackingJob(id);
                    }
                    return job;
                })
        )).then(function (v) {
            return v.filter(function (job) {
                // Filter expired jobs out from the results.
                return !!job;
            });
        });
    }

    /**
     * Return whether the two jobs are identical.
     * @param {any} a The first job in the comparison
     * @param {any} b The second job in the comparison
     */
    _jobsEqual(a, b) {
        return super._jobsEqual(a, b)
            && a.ProcessedCount === b.ProcessedCount
            && a.FailedCount === b.FailedCount
            && a.LocatedCount === b.LocatedCount
            && a.LocatedUnsureCount === b.LocatedUnsureCount
            && a.NoResultsCount === b.NoResultsCount
            && a.MultipleResultsCount === b.MultipleResultsCount
            && a.ErrorCount === b.ErrorCount
            && a.Description === b.Description;
    }
}
